<template>
	<div>
		<CRow>
			<CCol sm="12">
				<CCard>
					<CCardHeader> Liste des colis </CCardHeader>

					<CCardBody>
						<GDataTableRemote
							ref="mainTable"
							:remote-url="`/api/order_items`"
							:fields="fields"
							:items-per-page="10"
							hover
							striped
							sorter
							columnFilter
							pagination>
							<template #state="{ item }">
								<td>
									<CBadge :color="statusColor[item.state]">{{
										statusTranslation[item.state]
									}}</CBadge>
								</td>
							</template>

							<template #parentOrder.status="{ item }">
								<td>
									<CBadge :color="orderStatusColor[item.parentOrder.status]">{{
										orderStatusTranslation[item.parentOrder.status]
									}}</CBadge>
								</td>
							</template>

							<template #parentOrder.concept="{ item }">
								<td>
									<CBadge :color="orderConceptColor[item.parentOrder.concept]">{{
										orderConceptTranslation[item.parentOrder.concept]
									}}</CBadge>
								</td>
							</template>

							<template #supportTickets.status="{ item }">
								<td>
									<CBadge
										:color="
											item.supportTickets.length > 0
												? supportTicketsStatusColor[item.supportTickets[0].status]
												: 'success'
										">
										{{
											item.supportTickets.length > 0
												? supportTicketsStatusTranslation[
														item.supportTickets[0].status
													]
												: 'Aucun'
										}}
									</CBadge>
								</td>
							</template>

							<template #shippingNumber="{ item }">
								<td>
									<template v-if="item.shippingNumber">
										<a
											target="_blank"
											:href="`https://www.chronopost.fr/tracking-no-cms/suivi-page?listeNumerosLT=${item.shippingNumber}`">
											{{ item.shippingNumber }}
											<CIcon class="ml-1" name="cil-external-link" />
										</a>
									</template>
									<template v-else>
										<CIcon name="cil-ban" />
									</template>
								</td>
							</template>

							<template #search_expeditor="{ item }">
								<td>
									{{
										`${item.parentOrder.senderAddress.firstName} ${item.parentOrder.senderAddress.lastName} | ${item.parentOrder.senderAddress.address}, ${item.parentOrder.senderAddress.postalCode} ${item.parentOrder.senderAddress.city}`
									}}
								</td>
							</template>

							<template #search_receiver="{ item }">
								<td>
									<template v-if="item.receiverAddress">
										{{
											`${item.receiverAddress.firstName} ${item.receiverAddress.lastName} | ${item.receiverAddress.address}, ${item.receiverAddress.postalCode} ${item.receiverAddress.city}`
										}}
									</template>
									<template v-else>
										<CIcon name="cil-ban" />
									</template>
								</td>
							</template>

							<template #actions="{ item }">
								<td class="text-center">
									<router-link
										class="btn btn-link px-1"
										title="Voir la commande"
										:to="`/orders/${item.parentOrder.id}/edit`">
										<CIcon name="cil-magnifying-glass" />
									</router-link>
									<button
										v-if="item.supportTickets.length <= 0"
										class="btn btn-link px-1"
										title="Ouvrir un litige"
										@click.prevent="openTicketModal(item)">
										<CIcon name="cil-warning" />
									</button>
								</td>
							</template>
						</GDataTableRemote>
					</CCardBody>
				</CCard>
			</CCol>
		</CRow>

		<add-ticket-on-package ref="addTicketModal" />
	</div>
</template>
<script>
	import GDataTableRemote from '../../../../components/ghostlexly-components/GDataTableRemote';
	import AddTicketOnPackage from '@/components/modals/add-ticket-on-package';

	export default {
		components: {
			AddTicketOnPackage,
			GDataTableRemote,
		},
		data() {
			this.statusOptions = [
				{ value: 'order_item.pending', label: 'Etiquette non-imprimée' },
				{ value: 'order_item.label_printed', label: 'Etiquette imprimée' },
				{ value: 'order_item.orphan', label: 'Dé-scannée' },
				{ value: 'order_item.scanned', label: 'Etiquette scannée' },
				{ value: 'order_item.paused', label: 'En pause' },
				{ value: 'order_item.refunded', label: 'Remboursé' },
			];

			this.orderStatusOption = [
				{ value: 'order.pending', label: 'En attente' },
				{ value: 'order.paid', label: 'Payée' },
				{ value: 'order.awaiting_delayed_payment', label: 'En attente de paiement différé' },
				{ value: 'order.paused', label: 'En pause' },
				{ value: 'order.admin_authorized', label: 'Autorisation direction' },
				{ value: 'order.complete', label: 'Terminée' },
				{ value: 'order.payment_issue', label: 'Erreur de paiement' },
				{ value: 'order.canceled', label: 'Annulée' },
				{ value: 'order.refund', label: 'Remboursée' },
			];

			this.orderConceptOptions = [
				{ value: 'order.colipays', label: 'Colipays' },
				{ value: 'order.colikado', label: 'Colikado' },
				{ value: 'order.aupaysdesfleurs', label: 'Au pays des fleurs' },
			];

			return {
				fields: [
					{ key: 'reference', label: '#' },
					{ key: 'parentOrder.id', label: 'N° Commande' },
					{ key: 'slip.identifier', label: 'N° Bordereau' },
					{ key: 'name', label: 'Nom' },
					{
						key: 'state',
						label: 'Statut',
						type: 'select',
						filterSelectOptions: this.statusOptions,
						sorter: false,
					},
					{
						key: 'parentOrder.status',
						label: 'Statut commande',
						type: 'select',
						filterSelectOptions: this.orderStatusOption,
						sorter: false,
					},
					{ key: 'supportTickets.status', label: 'Statut litige', sorter: false, filter: false },
					{
						key: 'parentOrder.concept',
						label: 'Concept',
						type: 'select',
						filterSelectOptions: this.orderConceptOptions,
						sorter: false,
					},
					{ key: 'parentOrder.createdAt', label: 'Date de commande', type: 'daterange' },
					{ key: 'shippingDate', label: "Date d'envoi", type: 'daterange' },
					{ key: 'deliveryDate', label: 'Date de récéption', type: 'daterange' },
					{ key: 'shippingNumber', label: 'Suivi Chronopost', sorter: false },
					{ key: 'search_expeditor', label: 'Expéditeur', sorter: false },
					{ key: 'search_receiver', label: 'Destinataire', sorter: false },
					{ key: 'slip.salePts.name', label: 'Point de vente', sorter: false },
					{ key: 'slip.depotPts.name', label: 'Point de dépôt', sorter: false },
					{ key: 'actions', filter: false },
				],

				orderConceptTranslation: {
					'order.colipays': 'Colipays',
					'order.colikado': 'Colikado',
					'order.aupaysdesfleurs': 'Au pays des fleurs',
				},
				orderConceptColor: {
					'order.colipays': 'warning',
					'order.colikado': 'danger',
					'order.aupaysdesfleurs': 'success',
				},

				statusTranslation: {
					'order_item.pending': 'Étiquette non imprimée',
					'order_item.label_printed': 'Étiquette imprimée',
					'order_item.orphan': 'Colis retirés',
					'order_item.scanned': 'Colis scanné',
					'order_item.paused': 'Colis en pause',
					'order_item.refunded': 'Colis remboursé',
				},
				statusColor: {
					'order_item.pending': 'danger',
					'order_item.label_printed': 'warning',
					'order_item.orphan': 'warning',
					'order_item.scanned': 'success',
					'order_item.paused': 'danger',
					'order_item.refunded': 'warning',
				},

				orderStatusTranslation: {
					'order.paused': 'En pause',
					'order.pending': 'En attente de paiement (CB)',
					'order.awaiting_delayed_payment': 'En attente de paiement différé',
					'order.paid': 'Payée',
					'order.admin_authorized': 'Autorisation direction',
					'order.complete': 'Terminée',
					'order.payment_issue': 'Erreur de paiement',
					'order.canceled': 'Annulée',
					'order.refund': 'Remboursée',
				},
				orderStatusColor: {
					'order.paused': 'warning',
					'order.pending': 'warning',
					'order.awaiting_delayed_payment': 'warning',
					'order.paid': 'success',
					'order.admin_authorized': 'success',
					'order.complete': 'success',
					'order.payment_issue': 'danger',
					'order.canceled': 'danger',
					'order.refund': 'warning',
				},

				contactChannelTranslation: {
					'order.contact_channel.show_room': 'Show-room',
					'order.contact_channel.web': 'Web',
					'order.contact_channel.letter': 'Lettre',
					'order.contact_channel.email': 'Email',
					'order.contact_channel.phone': 'Téléphone',
				},
				supportTicketsStatusTranslation: {
					'support_ticket.status.new': 'Nouveau',
					'support_ticket.status.ongoing': 'En cours',
					'support_ticket.status.closed': 'Clôturé',
				},
				supportTicketsStatusColor: {
					'support_ticket.status.new': 'primary',
					'support_ticket.status.ongoing': 'warning',
					'support_ticket.status.closed': 'danger',
				},
			};
		},
		methods: {
			refresh: function () {
				this.$refs.mainTable.refresh();
			},
			openTicketModal(orderItem) {
				this.$refs.addTicketModal.showModal = true;
				this.$refs.addTicketModal.orderItem = orderItem;
			},
		},
	};
</script>
